// src/hooks/useRoleAccess.ts
import { useAuthStore } from '../store/authStore';
// Локальное определение RoleEnum
enum RoleEnum {
  SUPER_ADMIN = 'SUPER_ADMIN',
  OWNER = 'OWNER',
  ADMIN = 'ADMIN',
  RECRUITER = 'RECRUITER'
}

export const useRoleAccess = () => {
  const { user } = useAuthStore();

  return {
    isSuperAdmin: user && 'role' in user && user.role === RoleEnum.SUPER_ADMIN,
    isOwner: user && 'role' in user && user.role === RoleEnum.OWNER,
    isAdmin: user && 'role' in user && user.role === RoleEnum.ADMIN,
    isRecruiter: user && 'role' in user && user.role === RoleEnum.RECRUITER,

    isCandidate: user && (!('role' in user) || user.role === undefined),
    canCreate: user && 'role' in user && (user.role === RoleEnum.SUPER_ADMIN || user.role === RoleEnum.OWNER || user.role === RoleEnum.ADMIN || user.role === RoleEnum.RECRUITER),
    canEdit: user && 'role' in user && (user.role === RoleEnum.SUPER_ADMIN || user.role === RoleEnum.OWNER || user.role === RoleEnum.ADMIN || user.role === RoleEnum.RECRUITER),
    canDelete: user && 'role' in user && (user.role === RoleEnum.SUPER_ADMIN || user.role === RoleEnum.OWNER || user.role === RoleEnum.ADMIN),
    canManageTeam: user && 'role' in user && (user.role === RoleEnum.SUPER_ADMIN || user.role === RoleEnum.OWNER || user.role === RoleEnum.ADMIN),
    canManageSettings: user && 'role' in user && (user.role === RoleEnum.SUPER_ADMIN || user.role === RoleEnum.OWNER || user.role === RoleEnum.ADMIN),
  };
}; 